import { createContext, useContext, useState } from 'react'
import { WebSocketContext } from '../WebSocket/WebSocketContext'

export const OrdemServicoContext = createContext()

export const OrdemServicoProvider = ({ children }) => {
    const { sendWs } = useContext(WebSocketContext)

    const [idEdit, setIdEdit] = useState()
    const [filtros, setFiltros] = useState()
    const [imprimindo, setImprimindo] = useState(false)

    const buscarOrdensServico = (id_central) => {
        let filtrosPesquisa = { ...filtros }

        if (typeof id_central === 'string' && id_central) {
            filtrosPesquisa.id_central = id_central
            setFiltros({ id_central })
        }

        if (filtrosPesquisa.id_central === 'all') {
            delete filtrosPesquisa.id_central
        }

        sendWs("buscarOrdensServico", { filtros: filtrosPesquisa })
    }

    const value = {
        buscarOrdensServico,
        idEdit,
        filtros,
        setIdEdit,
        setFiltros,
        imprimindo,
        setImprimindo
    }

    return (
        <OrdemServicoContext.Provider value={value}>
            <div>
                {children}
            </div>
        </OrdemServicoContext.Provider>
    )
}
